import {
  Grid,
  Button,
  CardHeader,
  Dialog,
  DialogContent,
  DialogActions,
  DataGrid,
  Chip,
} from "../../../../../components";

const ProdutoSimilarDialog = ({
  produto,
  openProdutoSimilarDialog,
  setOpenProdutoSimilarDialog,
  produtosColunasSimilares,
  listaProdutosSimilares,
}) => {
  return (
    <Dialog fullWidth maxWidth={"md"} open={openProdutoSimilarDialog}>
      <CardHeader title="Produto Similar" className="m-2" />
      <DialogContent>
        <Grid item xs={12}>
          <Chip
            label={`${produto?.codigo} - ${produto?.descricao}`}
            className="mb-2"
            color={"success"}
            sx={{
              borderRadius: "4px",
              height: "23px",
              clipPath: `polygon(0% 0%, calc(100% - 10px) 0%, 100% 50%, calc(100% - 10px) 100%, 10px 100%, 0% 100%)`,
              "& .MuiChip-label": {
                fontWeight: "600",
                fontSize: "11px",
                letterSpacing: ".2px",
              },
            }}
          />
        </Grid>
        <DataGrid
          rows={listaProdutosSimilares}
          columns={produtosColunasSimilares}
          rowCount={listaProdutosSimilares?.length}
          disableAcoes
        />
      </DialogContent>
      <DialogActions className="m-3">
        <Button
          onClick={() => setOpenProdutoSimilarDialog(false)}
          color="primary"
          variant="contained"
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProdutoSimilarDialog;
